import React, {useContext, useEffect, useState} from "react";
import {Modal, Platform, ScrollView, View} from "react-native";
import MainStyle from "../../MainStyle";
import Div from "../lib/Div";
import P from "../lib/P";
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import Btn from "../components/Btn";
import {StoreContext} from "../components/StoreContextProvider";
import {LANDING_PAGE_URL} from "../constants";

type Props = { visible: boolean, onRequestClose: (keepPlaying?: boolean) => void };

const ShortTimerModal = (props: Props) => {
  const {visible} = props;
  const [seconds, setSeconds] = useState(29);
  const Context = useContext(StoreContext);

  const logout = () => {
    props.onRequestClose();

    Context.logout().then(() => {
      if (Platform.OS === 'web') window.open(LANDING_PAGE_URL, '_self');
      Context.setLoadingOverlay(false);
    });
  };

  useEffect(() => {
    if (seconds < 1) logout();
  }, [seconds]);

  useEffect(() => {
    if (!visible) {
      setSeconds(29);
      return;
    }

    const time = setInterval(() => {
      setSeconds(seconds => seconds - 1);
    }, 1000);

    return () => {
      clearInterval(time);
    };
  }, [visible]);

  return (
    <Modal animationType="fade" transparent visible={visible} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={() => props.onRequestClose()}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <Div minH="100%" alignItems="center" justifyContent="center">
            <Div bg="#131314" w={343} rounded={16} overflow="hidden">
              <Div position="relative" bg="#252526" justifyContent="center">
                <P fontFamily="DavisSans-Medium" ta="center" lh={48}>Are you still there?</P>
              </Div>

              <Div px={16} pb={30} pt={40} alignItems="center">
                <MaterialCommunityIcons name="information" size={48} color="#C73232" style={MainStyle.m_b_15}/>

                <P fontFamily="DavisSans-Regular" ta="center" mb={10}>
                  Keep playing or you will be logged out in:
                </P>

                {seconds > 0 && (
                  <P fontFamily="DavisSans-Medium" fs={18} color="#F55656" ta="center" mb={40}>{seconds} seconds...</P>
                )}

                <Btn borderWidth={2} borderColor="white" onPress={logout} w="100%" mb={20}>
                  <P fontFamily="DavisSans-Medium" lh={56} ta="center">Log Out</P>
                </Btn>

                <Btn bg="#3369FF" onPress={() => props.onRequestClose(true)} w="100%">
                  <P fontFamily="DavisSans-Medium" lh={56} ta="center">Keep Playing</P>
                </Btn>
              </Div>
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default ShortTimerModal;
